import React from 'react';
import styled from 'styled-components/macro';
import { color } from 'styled-system';
import { Input } from '../SubComponents/Inputs';
import { Label } from '../SubComponents/Text';
import { Row } from '../SubComponents/Modals';
import useLocalize from '../Hooks/useLocalize';

const Required = styled(Label)`
  color: ${(props) => props.theme.errorColor};
`;

const NewsletterContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
  padding: 0 15px;
  ${color}

  @media screen and (max-width: 767px) {
    color: #fff;
    margin-bottom: 16px;
    padding: 0;
  }
`;

interface NewsletterProps {
  subscribed: boolean | null;
  text: string;
  onChange: (subscribed: boolean) => void;
  error?: boolean;
  textColor?: string;
}

const Newsletter = (props: NewsletterProps) => {
  const localize = useLocalize();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const subscribed = event.target.value === 'true' ? true : false;

    props.onChange(subscribed);
  };

  return (
    <NewsletterContainer>
      <>
        <Row justifyContent="center" mb="2">
          <Label color={props.textColor} textAlign="center">
            {props.text}
          </Label>
          <Required ml="1">*</Required>
        </Row>

        <Row width="fit-content !important" m="0 auto" justifyContent="space-between">
          <Input
            id="true"
            type="radio"
            value="true"
            checked={props.subscribed === true}
            onChange={handleChange}
            borderRadius="10px"
            error={props.error}
          />
          <Label color={props.textColor} htmlFor="true" pl="2" mr="4">
            {localize('product.yes')}
          </Label>

          <Input
            id="false"
            type="radio"
            value="false"
            checked={props.subscribed === false}
            onChange={handleChange}
            borderRadius="10px"
            error={props.error}
          />
          <Label color={props.textColor} htmlFor="false" pl="2">
            {localize('product.no')}
          </Label>
        </Row>
      </>
    </NewsletterContainer>
  );
};

export default Newsletter;
